<template>
  <action-panel-dots v-if="!$presenter.isPublic">
    <mobile-nav class="mt-4">
      <nav-item title="Revisions" id="revList" v-if="show && selectedRev">
        <template v-slot:default>
          <template v-for="rev in bcDocumentStore.revisions" :key="rev.id">
            <nav-item :title="revText(rev)" :url="rev.url">
              <template v-slot:link>
                <a :href="rev.url" class="flex items-center justify-center">
                  <ui-pictogram class="mr-1.5" :user="rev.published__user ? rev.published__user : (rev.created__user ? rev.created__user : undefined)" v-if="rev.published__user || rev.created__user" />
                  <span class="flex-grow text-sm" :class="{ 'text-red-600': !rev.published, 'text-green-600': rev.id === publishedRev?.id }" v-html="revText(rev)"></span>
                  <span v-if="selectedRev?.id === rev.id"
                    ><aw-icon
                      icon="tick"
                      class="relative !w-4 !h-4  text-bc-blue mr-4"
                    ></aw-icon
                  ></span>
                </a>
              </template>
            </nav-item>
          </template>
        </template>
        <template v-slot:link="{ open }">
          <div @click="open" class="flex items-center justify-center space-x-2">
            <ui-pictogram class="mr-1.5" :user="selectedRev.published__user ? selectedRev.published__user : (selectedRev.created__user ? selectedRev.created__user : undefined)" v-if="selectedRev.published__user || selectedRev.created__user" />
            <span class="flex-grow text-sm" :class="{ 'text-red-600': !selectedRev.published, 'text-green-600': selectedRev.id === publishedRev?.id }" v-html="revText(selectedRev)"></span>
            <aw-icon
              icon="chevron-right"
              class="w-6.5 h-6.5  text-gray-500 mr-4"
            ></aw-icon>
          </div>
        </template>
      </nav-item>
      <!--
      <nav-item title="Document info" icon="info" />
      -->
    </mobile-nav>
  </action-panel-dots>
</template>

<script>
import formatDate from 'nette-base-module/js/utils/formatDate'
import DocumentStore from '../../mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  computed: {
    show () {
      return this.bcDocumentStore.document.can_edit
    },
    selectedRev () {
      return this.bcDocumentStore.revisions.filter(rev => rev.id === this.bcDocumentStore.document.bc_document_rev_id)[0]
    },
    publishedRev () {
      return this.bcDocumentStore.revisions.filter(rev => rev.id === this.bcDocumentStore.document.published__bc_document_rev_id)[0]
    },
  },
  methods: {
    revText (rev) {
      return (rev.id === this.publishedRev?.id
        ? this.$t('Published') + '<br />' + formatDate(rev.published, 'd. m. y H:i')
        : ( !rev.published ? this.$t('Last edit') + '<br />' + formatDate(rev.created, 'd. m. y H:i') : this.$t('Revision') + ' ' + rev.revision + '<br />' + formatDate(rev.published, 'd. m. y H:i')))
    }
  }
};
</script>

<style lang="scss" scoped></style>
